import React from 'react';
import TitleSummaryList from './TitleSummary';
import SummaryList from './SummaryList';
import { formatCurrency } from '../../utils/currency.utils';
import { RailCard } from '../resultCards';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
const TripRailList = ({ response, onSelect, currency, currencyCulture }) => {
  const { t } = useTranslation(i18nNS.tripSummary);
  const { tKey } = useComponentTKey('RailSummaryList');
  return (
    <>
      <TitleSummaryList
        desc={1 + ' ' + t(tKey('Traveler'))}
        amount={formatCurrency(response.TotalFare, currency, currencyCulture)}
        iconName="rail"
      />
      <SummaryList>
        {response.RailLegs.map((leg) => (
          <RailCard
            key={leg.LegNumber}
            onPress={onSelect}
            item={leg}
            textUpIcon={leg.DepartDate}
            disableDetails
            hidePrice
            showVendorName
          />
        ))}
      </SummaryList>
    </>
  );
};

export default TripRailList;
